/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flight_deck";

/**
 * NOTE(sam): This is reflected as a postgres enum in the cloud api database. Do not rename any of
 * these values! And any new options created here will require a database migration.
 */
export interface NavigationMode {
}

export enum NavigationMode_Mode {
  UNKNOWN = 0,
  DEFAULT_NAV = 0,
  /** AUTONOMY_OFF - GPS flight with obstacle avoidance disabled. It can be used for night flights. */
  AUTONOMY_OFF = 2,
  /** VESSEL_MODE - GPS flight with obstacle avoidance enabled. It can be used on moving vessels. */
  VESSEL_MODE = 3,
  /**
   * TWILIGHT - DEPRECATED: X2/E1 only, no longer supported. Do not use.
   * Representative of well lit, outdoor environments during night time. We expect to have VIO
   * during takeoff through gps initialization, atleast. However, we do not support obstacle
   * avoidance.
   *
   * @deprecated
   */
  TWILIGHT = 4,
  /**
   * NIGHT_AUTONOMY - VIO flight with obstacle avoidance enabled. Used with illumination package to enable flight
   * at night
   */
  NIGHT_AUTONOMY = 5,
  UNRECOGNIZED = -1,
}

export function navigationMode_ModeFromJSON(object: any): NavigationMode_Mode {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return NavigationMode_Mode.UNKNOWN;
    case 0:
    case "DEFAULT_NAV":
      return NavigationMode_Mode.DEFAULT_NAV;
    case 2:
    case "AUTONOMY_OFF":
      return NavigationMode_Mode.AUTONOMY_OFF;
    case 3:
    case "VESSEL_MODE":
      return NavigationMode_Mode.VESSEL_MODE;
    case 4:
    case "TWILIGHT":
      return NavigationMode_Mode.TWILIGHT;
    case 5:
    case "NIGHT_AUTONOMY":
      return NavigationMode_Mode.NIGHT_AUTONOMY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NavigationMode_Mode.UNRECOGNIZED;
  }
}

export function navigationMode_ModeToJSON(object: NavigationMode_Mode): string {
  switch (object) {
    case NavigationMode_Mode.UNKNOWN:
      return "UNKNOWN";
    case NavigationMode_Mode.DEFAULT_NAV:
      return "DEFAULT_NAV";
    case NavigationMode_Mode.AUTONOMY_OFF:
      return "AUTONOMY_OFF";
    case NavigationMode_Mode.VESSEL_MODE:
      return "VESSEL_MODE";
    case NavigationMode_Mode.TWILIGHT:
      return "TWILIGHT";
    case NavigationMode_Mode.NIGHT_AUTONOMY:
      return "NIGHT_AUTONOMY";
    case NavigationMode_Mode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseNavigationMode(): NavigationMode {
  return {};
}

export const NavigationMode = {
  encode(_: NavigationMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NavigationMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNavigationMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): NavigationMode {
    return {};
  },

  toJSON(_: NavigationMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<NavigationMode>, I>>(base?: I): NavigationMode {
    return NavigationMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NavigationMode>, I>>(_: I): NavigationMode {
    const message = createBaseNavigationMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
